export default "__VITE_ASSET__D8xk5Ir2__"